import { render, staticRenderFns } from "./UnitClosingDatesInfo.vue?vue&type=template&id=db916efa&scoped=true&"
import script from "./UnitClosingDatesInfo.vue?vue&type=script&lang=ts&"
export * from "./UnitClosingDatesInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db916efa",
  null
  
)

export default component.exports